<template>
  <div class="coupon" :class="{ disabled: oCoupon.expiration && expiration }">
    <div class="d-flex align-center justify-between mb_20">
      <div class="d-flex align-center">
        <i :class="['ticket-icon', 'fas fa-ticket-alt fa-3x']"></i>
        <p :class="['coupon-code']">{{ oCoupon.code }}</p>
      </div>
    </div>

    <div class="d-flex align-center justify-between">
      <div>
        <p class="field-title">Benefício oferecido</p>
        <p>{{ couponAmount() }}</p>
      </div>
      <div class="text-right">
        <p class="field-title">Modo de uso</p>
        <p>{{ couponType() }}</p>
      </div>
    </div>

    <base-radio
      v-if="!oCoupon.expiration"
      class="coupon-radio"
      family="coupon"
      :option="oCoupon.code"
      v-model="couponCode"
      @click="(couponCode = oCoupon.code), getCouponDetails()"
    />
  </div>
</template>
<script>
import Gift, { TYPE as aTypes } from 'easyjs/lib/Schema/Gift';
import Utils from '@/utils';
import BaseRadio from '@/components/Radio';
import ModulesApi from '@/api/modules/modules';

export default {
  props: {
    coupon: { type: Object, required: true, default: {} },
    couponSelected: { type: String, required: false },
    expiration: { type: Boolean, default: false },
  },
  components: {
    BaseRadio,
  },
  data() {
    return {
      oCoupon: {},
      couponCode: '',
    };
  },
  async beforeCreate() {
    this.finishedMount = false;
    const performance = await ModulesApi.getModuleEnvironment();
    if (performance.getData([]).length === 0) {
      this.$router.push({ name: 'pedidos' });
    }

    this.finishedMount = true;
  },
  created() {
    this.oCoupon = Gift.fromObject(this.coupon);
    this.couponCode = this.couponSelected;
  },
  methods: {
    getCouponDetails() {
      return this.$emit(
        'selectCoupon',
        this.couponCode,
        this.couponAmount(),
        this.couponType()
      );
    },
    couponAmount() {
      if (this.oCoupon.typeIs(aTypes.DELIVERY)) {
        return 'Entrega Grátis';
      }

      if (this.oCoupon.typeIs(aTypes.PERCENT)) {
        return `${this.oCoupon.value}%`;
      }

      if (this.oCoupon.typeIs(aTypes.PRICE)) {
        return Utils.convertMoney(this.oCoupon.value, 'R$', '');
      }

      return false;
    },
    couponType() {
      if (this.oCoupon.typeIs(aTypes.FREE_TO_USE)) {
        return 'Usos ilimitados por cadastro';
      }

      if (this.oCoupon.typeIs(aTypes.N_USE)) {
        return 'Uso único por cadastro';
      }

      return false;
    },
  },
};
</script>
<style scoped>
.coupon {
  background: var(--box-up);
  padding: 20px;
  border-radius: 5px;
  position: relative;
}
.coupon-code {
  font-size: 14px;
  line-height: 17px;
  font-weight: 900;
  color: var(--default);
}
.coupon-radio {
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  bottom: 0;
  width: 100%;
}
.field-title {
  text-transform: uppercase;
  color: #bfbfbf;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
}
.field-title + p {
  font-size: 10px;
  color: #bfbfbf;
  margin-top: 5px;
  line-height: 12px;
}
.ticket-icon {
  color: var(--default);
  margin-right: 15px;
  font-size: 26px;
}
.coupon.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.coupon.disabled .coupon-radio {
  pointer-events: none;
}
.coupon.disabled .ticket-icon,
.coupon.disabled .coupon-code {
  color: #aaaaab;
}

@media screen and (max-width: 991px) {
  .field-title,
  .field-title + p {
    font-size: 1em;
  }
  .coupon-code {
    font-size: 1.4em;
  }
  .field-title {
    font-size: 1em;
  }
  .field-title + p {
    font-size: 1em;
  }
}
</style>
